'use client';

import { ElementProps } from '@/components/sections/builder/types';
import {
  ImageWithTextButtonElementDataType,
  ImageWithTextElementDataType,
} from '@/components/sections/builder/elements/body/image-with-text/types';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { Input } from '@/components/ui/input';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';
import { GalleryHorizontal } from 'lucide-react';
import InputLink from '@/components/sections/builder/settings/input-link';
import { Checkbox } from '@/components/ui/checkbox';
import clsx from 'clsx';
import ShopIcon from '@/components/icons/shop-store-icon';
import Link from 'next/link';

const defaultData: ImageWithTextButtonElementDataType = {
  name: 'Button',
  buttonLabel: 'Button label',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ImageWithTextButtonElementDataType;
  const parentData = element.parentData as ImageWithTextElementDataType;

  const isExternal = data.buttonUrl?.includes('http');

  return (
    <div className='button-padding '>
      {!!data.buttonLabel && (
        <button
          className={clsx(
            'mt-3 flex items-center  gap-x-2 break-all px-6 py-3 text-left md:w-full lg:mt-0 ',
            parentData.containerColorScheme &&
              `button_container_${!data.isOutlineButton ? 'solid' : 'outline'}`,
            !data.isOutlineButton
              ? 'button_container_solid focus:ring-primary-300 items-center justify-center rounded-md  text-center text-base font-medium text-white hover:bg-primary focus:ring-4'
              : 'button_container_outline items-center justify-center rounded-md border border-gray-300 text-center text-base font-medium  hover:bg-gray-100 focus:ring-4 focus:ring-gray-100'
          )}
          data-animation='true'
        >
          <Link
            href={
              isExternal ? data.buttonUrl || '#' : `/${(data.buttonUrl || '').replace(/^\/+/, '')}`
            }
            className='flex'
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
          >
            {data.showIconButton && <ShopIcon className='mr-2 h-5 w-5' />}
            {data.buttonLabel}
          </Link>
        </button>
      )}
      <style jsx>
        {`
          .button_container_solid {
            background-color: ${parentData.containerColorScheme?.btnSolidBackgroud};
            color: ${parentData.containerColorScheme?.btnSolidlabel};
          }

          .button_container_outline {
            background-color: transparent;
            color: ${parentData.containerColorScheme?.btnOutline};
            outline-color: ${parentData.containerColorScheme?.btnOutline};
          }

          @media (min-width: 1024px) {
            .button-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }
        `}
      </style>
    </div>
  );
};

export const ElementPreviewIcon = GalleryHorizontal;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = (element.data || defaultData) as ImageWithTextButtonElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Button</div>
      <Input
        onChange={(e) =>
          builder.setChildData(element.parentId as string, element.id, {
            buttonLabel: e.target.value,
          })
        }
        name='buttonLabel'
        type='text'
        size={100}
        defaultValue={data.buttonLabel}
        className='w-full'
        placeholder='Label'
      />
      <div className='mb-4 mt-4 font-bold'>Button url</div>
      <InputLink
        name='buttonUrl'
        placeholder='Search or enter a link'
        onChange={(value) => {
          builder.setChildData(element.parentId as string, element.id, {
            buttonUrl: value,
          });
        }}
        value={data.buttonUrl as string}
      />
      <div className='mt-4 flex items-center'>
        <Checkbox
          checked={data.isOutlineButton}
          onCheckedChange={(value) =>
            builder.setChildData(element.parentId as string, element.id, {
              isOutlineButton: !!value,
            })
          }
          className='mr-4'
        />
        <p>Use outline button style</p>
      </div>
      <PaddingSetting
        value={data.padding}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            padding: v,
          })
        }
      />
      <div className='mt-4 flex items-center'>
        <Checkbox
          checked={data.showIconButton}
          onCheckedChange={(value) =>
            builder.setChildData(element.parentId as string, element.id, {
              showIconButton: !!value,
            })
          }
          className='mr-4'
        />
        <p>Show icon button</p>
      </div>
    </div>
  );
}

const ImageWithTextButton = {
  type: 'image_with_text_button',
  group: 'image_with_text',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default ImageWithTextButton;

// <Link
//   href={data.buttonUrl ? `/${data.buttonUrl}` : '#'}
//   className={clsx(
//     'flex items-center  gap-x-2 break-all  px-6  py-2 text-left md:w-full ',
//     parentData.containerColorScheme &&
//       `button_container_${!data.isOutlineButton ? 'solid' : 'outline'}`,
//     !data.isOutlineButton
//       ? 'button_container_solid focus:ring-primary-300 items-center justify-center rounded-md  text-center text-base font-medium text-white hover:bg-primary focus:ring-4'
//       : 'button_container_outline items-center justify-center rounded-md border border-gray-300 text-center text-base font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100'
//   )}
//   data-animation='true'
// >
//   {data.showIconButton && <ShopIcon className='w-5 h-5 mr-2' />}
//   {data.buttonLabel}
// </Link>
